import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0,1016.08141 L409.185882,1425.15435 L489.035294,1345.41788 L216.169412,1072.43906 L1352.58353,1072.43906 L1352.58353,959.610824 L216.169412,959.610824 L489.035294,686.744941 L409.185882,606.895529 L0,1016.08141 Z M1465.59247,305.32 L1781.03718,620.764706 L1465.59247,620.764706 L1465.59247,305.32 Z M1867.776,547.691765 L1538.55247,218.581176 C1507.04188,187.070588 1463.33365,169 1418.83482,169 L675.004235,169 L675.004235,846.647059 L787.945412,846.647059 L787.945412,281.941176 L1352.65129,281.941176 L1352.65129,733.705882 L1804.416,733.705882 L1804.416,1637.23529 L787.945412,1637.23529 L787.945412,1185.47059 L675.004235,1185.47059 L675.004235,1750.17647 L1917.35718,1750.17647 L1917.35718,667.522353 C1917.35718,623.023529 1899.28659,579.315294 1867.776,547.691765 L1867.776,547.691765 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconExportLine = /*#__PURE__*/function (_Component) {
  _inherits(IconExportLine, _Component);

  var _super = _createSuper(IconExportLine);

  function IconExportLine() {
    _classCallCheck(this, IconExportLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconExportLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExport",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconExportLine.displayName = "IconExportLine";
  return IconExportLine;
}(Component);

IconExportLine.glyphName = 'export';
IconExportLine.variant = 'Line';
IconExportLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExportLine;
export { IconExportLine };